import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { GenericTableField } from '../../../models/generic-table-field';

@Component({
	selector: 'app-table-generic',
	templateUrl: './table-generic.component.html',
	styleUrls: ['./table-generic.component.css'],
})
export class TableGenericComponent implements OnInit {
	@Input() headerFields: GenericTableField[];
	@Input() rowsObject = [];
	@Input() footerFields: GenericTableField[];
	@Input() rowObject: any;
	@Input() ngClassRow = "";
	//@Input() enableNewRow: boolean = false;
	@Output() sendData = new EventEmitter();
	@Output() newItem = new EventEmitter();

	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild(MatSort) sort: MatSort;
	displayedColumns = [];
	rowsObjectLength: number = 0;
	rowsObjectCopy = [];
	rowsObjectObservable: MatTableDataSource<any>;

	constructor() { }

	ngOnInit() {
		this.rowsObjectCopy = this.rowsObject;
		this.rowsObjectObservable = new MatTableDataSource<any>(this.rowsObjectCopy);
	}

	ngOnChanges(changes: any){
		//console.log('CHANGE TABLE GENERIC', changes);
		if(changes.rowsObject){
			//console.log('CHANGE TABLE GENERIC ROWOBJECT');
			this.rowsObjectLength = (this.rowsObject) ? this.rowsObject.length : 0;
			this.rowsObjectCopy = this.rowsObject;
			this.generateRowsObjectObservable();
		}
	}

	ngAfterViewInit() {
		//console.log("ngAfterViewInit sort", this.sort);
		this.rowsObjectObservable.sort = this.sort;
	}

	generateRowsObjectObservable(){
		this.displayedColumns = [];
		if(this.headerFields){
			for(let headerField of this.headerFields){
				this.displayedColumns.push(headerField.code);
			}
			this.rowsObjectObservable = new MatTableDataSource<any>(this.rowsObjectCopy);
			this.rowsObjectObservable.paginator = this.paginator;
			this.rowsObjectObservable.sort = this.sort;
		}
	}

	sortData(){
		this.rowsObjectCopy = this.getSortedData();
		this.generateRowsObjectObservable();
	}

	getSortedData(): any[] {
		this.rowsObjectCopy = this.rowsObject;
		return this.rowsObjectCopy;
	}

	rowClick(row) {
		//console.log("sendData", this.sendData, row);
		if(this.sendData){
			this.sendData.emit(row);
		}
	}

	newClick() {
		//console.log("newItem", this.newItem);
		if(this.newItem){
			this.newItem.emit()
		}
	}
}
